// Collection-only ARKET presentation. Shopify owns products, variants and cart.
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ga-tag-link]');
    if (!link) return;
    const form = link.closest('facets-form-component[data-apply-on-demand]');
    if (form && typeof form.stageTag === 'function') {
      event.preventDefault();
      form.stageTag(link);
      return;
    }
    const url = new URL(link.href);
    const query = new URLSearchParams(window.location.search);
    query.delete('page');
    query.delete('filter.p.tag');
    url.search = query.toString();
    link.href = url.href;
  });
  const location = document.querySelector('[data-ga-location]');
  if (location) {
    try { location.hidden = sessionStorage.getItem('ga-location-dismissed') === 'true'; } catch {}
    location.querySelector('[data-ga-location-close]')?.addEventListener('click', () => {
      location.hidden = true;
      try { sessionStorage.setItem('ga-location-dismissed', 'true'); } catch {}
      window.dispatchEvent(new Event('resize'));
    });
    location.querySelector('[data-ga-locale]')?.addEventListener('click', event => {
      event.preventDefault();
      const locale = document.querySelector('.giesto-header__locale-code:not([disabled])');
      if (locale instanceof HTMLButtonElement) locale.click();
    });
  }
})();
